import $api from '../services';

export default {
    list(params) {
        return $api.get('/programs', params);
    },
    create(params) {
        return $api.post('/programs', params);
    },
    read(id) {
        return $api.get(`/programs/${id}`);
    },
    update(id, params) {
        return $api.put(`/programs/${id}`, params);
    },
    delete(id) {
        return $api.delete(`/programs/${id}`);
    }
};
